
/* globals google */
'use strict';

var storeLocator = require('../storeLocator/storeLocator');

function updateStoresResults(data, findStoreLink) {
	var isCart = $('.cart-page').length > 0 ? true : false;
	var $resultsDiv = isCart ? $('.results') : findStoreLink.parents('.attributes').find('.results');
	var $mapDiv = isCart ? $('.map-canvas') : findStoreLink.parents('.attributes').find('.map-canvas');
	var hasResults = data.stores.length > 0;

	if (!hasResults) {
		isCart ? $('.store-locator-no-results').show() : findStoreLink.parents('.attributes').find('.store-locator-no-results').show();
	} else {
		isCart ? $('.store-locator-no-results').hide() : findStoreLink.parents('.attributes').find('.store-locator-no-results').hide();
	}

	isCart ? $('.zipcode-input').val('') : findStoreLink.parents('.attributes').find('.zipcode-input').val('');
	$mapDiv.attr('data-locations', data.locations);
	if ($mapDiv.data('has-google-api')) {
		maps(findStoreLink);
	} else {
		isCart ? $('.store-locator-no-apiKey').show() : findStoreLink.parents('.attributes').find('.store-locator-no-apiKey').show();
	}
	$resultsDiv.empty()
		.data('has-results', hasResults)
		.data('radius', data.radius)
		.data('search-key', data.searchKey);

	if (data.storesResultsHtml) {
		$resultsDiv.append(data.storesResultsHtml);
	}
}

/**
 * Uses google maps api to render a map
 */
function maps(findStoreLink) {
	var isCart = $('.cart-page').length > 0 ? true : false;
	var map;
	var infowindow = new google.maps.InfoWindow();
	var googleMapID = $('.google-map-id').val();

	// Init U.S. Map in the center of the viewport
	var latlng = new google.maps.LatLng(37.09024, -95.712891);
	var mapOptions = {
		scrollwheel: false,
		zoom: 4,
		center: latlng,
		mapId: googleMapID
	};

	map = new google.maps.Map(isCart ? $('.map-canvas')[0] : findStoreLink.parents('.attributes').find('.map-canvas')[0], mapOptions);

	var defaultzoom = map.getZoom();

	var mapdiv = isCart ? $('.map-canvas').attr('data-locations') : findStoreLink.parents('.attributes').find('.map-canvas').attr('data-locations');

	mapdiv = JSON.parse(mapdiv);

	var bounds = new google.maps.LatLngBounds();

	map.addListener('zoom_changed', () => {
		var gtmData = {};
		gtmData.eventAction = 'Map Interaction';
		if (map.getZoom() <= defaultzoom) {
			gtmData.eventLabel = 'Zoom Out';
		} else if (map.getZoom() > defaultzoom) {
			gtmData.eventLabel = 'Zoom In';
		}
		defaultzoom = map.getZoom();
		$('body').trigger('storeloc:zoom', gtmData);
	});


	Object.keys(mapdiv).forEach(function (key) {
		var item = mapdiv[key];
		var lable = parseInt(key, 10) + 1;
		var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
		const markerImg = document.createElement('div');
		markerImg.className = 'marker-img';
		markerImg.textContent = lable.toString();
		var marker = new google.maps.marker.AdvancedMarkerElement({

			position: storeLocation,
			map: map,
			title: item.name,
			content: markerImg,
			gmpClickable: true

		});

		marker.addListener('click', function () {
			infowindow.setOptions({
				content: item.infoWindowHtml
			});
			infowindow.open(map, marker);
			//GTM Push for Selected store
			var gtmData = {};
			gtmData.eventAction = 'Map Interaction';
			gtmData.eventLabel = 'Select Store - ' + item.name;
			$('body').trigger('storeloc:mapmarker', gtmData);
		});

		// Create a minimum bound based on a set of storeLocations
		bounds.extend(marker.position);
	});
	// Fit the all the store marks in the center of a minimum bounds when any store has been found.
	if (mapdiv && mapdiv.length !== 0) {
		map.fitBounds(bounds);
	}

	var listener = google.maps.event.addListener(map, 'idle', function () {
		if ((mapdiv && mapdiv.length == 1) && map.getZoom() > 10) map.setZoom(10);
		google.maps.event.removeListener(listener);
	});
}

var exportStoreLocatorModal = {
	getStoreModal: function (findStoreLink) {
		var isCart = $('.cart-page').length > 0 ? true : false;
		if (findStoreLink) {
			var storePresent = findStoreLink.attr('data-store-present');
			if (storePresent === 'null' || typeof storePresent === 'undefined') {
				var $resultsDiv = isCart ? $('.results') : findStoreLink.parents('.attributes').find('.results');
				var $mapDiv = isCart ? $('.map-canvas') : findStoreLink.parents('.attributes').find('.map-canvas');
				isCart ? $('.store-locator-no-results').hide() : findStoreLink.parents('.attributes').find('.store-locator-no-results').hide();
				isCart ? $('.zipcode-input').val('') : findStoreLink.parents('.attributes').find('.zipcode-input').val('');
				$resultsDiv.empty();

				if ($mapDiv.data('has-google-api')) {
					$mapDiv.attr('data-locations', '[]');
					maps(findStoreLink);
				} else {
					isCart ? $('.store-locator-no-apiKey').show() : findStoreLink.parents('.attributes').find('.store-locator-no-apiKey').show();
				}
				$.spinner().stop();
				isCart ? $('#storeModalDialog').modal('show') : findStoreLink.parents('.attributes').find('#storeModalDialog').modal('show');
				!isCart ? $(document).trigger('gtm:storeModalDisplayed') : '';
			} else {
				var url = findStoreLink.attr('data-href');
				url = url + '&initialLoad=true';
				$.ajax({
					url: url,
					method: 'GET',
					success: function (data) {
						$.spinner().stop();
						updateStoresResults(data, findStoreLink);
						$('#storeModalDialog .find-store-csrf-token').attr('name', data.csrf.tokenName).attr('value', data.csrf.token);
						isCart ? $('.select-store').prop('disabled', true) : findStoreLink.parents('.attributes').find('.select-store').prop('disabled', true);
					}
				});
				isCart ? $('#storeModalDialog').modal('show') : findStoreLink.parents('.attributes').find('#storeModalDialog').modal('show');
				!isCart ? $(document).trigger('gtm:storeModalDisplayed') : '';
			}
			storeLocator.create_storeLocator_custom_dropdowns();
		}
	}
};

module.exports = exportStoreLocatorModal;